<template>
  <v-card-text class="py-6 px-6" v-if="subenh !== undefined">
    <p class="text-h6 font-weight-light white--text">
      <span class="dw_green--text mr-2">{{ subenh.label }}</span>
      {{ subenh.title }}
    </p>
    <v-alert
      v-if="err"
      type="error"
      color="danger"
      border="left"
      dense
      outlined
      class="mb-0">
      There was an unexpected error loading details of this enhancement.
    </v-alert>
    <div v-else>
      <p class="body-2 font-weight-light">
        <span class="white--text font-weight-regular">Control Enhancement: </span>
        {{ subenh.statement || '--' }}
      </p>
      <p class="body-2 font-weight-light mb-0">
        <span class="white--text font-weight-regular">Discussion: </span>
        {{ subenh.guidance || '--' }}
      </p>
    </div>
  </v-card-text>
</template>

<script>
export default {
  name: 'enhancementDetails',
  props: ['subenh', 'err']
};
</script>
